import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { Dropdown, DropdownMenu, DropdownToggle, Form } from 'reactstrap';

//import images
import logoSm from "../assets/images/logo-sm.png";
import logoDark from "../assets/images/logo-dark.png";
import logoLight from "../assets/images/logo-light.png";

//import Components
import FullScreenDropdown from '../Components/Common/FullScreenDropdown';
import ProfileDropdown from '../Components/Common/ProfileDropdown';

import { changeSidebarVisibility } from '../slices/thunks';
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from 'reselect';
// import ProfileDropdownCompany from "../Components/Common/ProfileDropdownCompany";

const Header = ({ onChangeLayoutMode, layoutModeType, headerClass }) => {
    const dispatch = useDispatch();

    const selectDashboardData = createSelector(
        (state) => state.Layout,
        (sidebarVisibilitytype) => sidebarVisibilitytype.sidebarVisibilitytype
      );
    // Inside your component
    const sidebarVisibilitytype = useSelector(selectDashboardData);

    const [search, setSearch] = useState(false);
    const toogleSearch = () => {
        setSearch(!search);
    };

    const toogleMenuBtn = () => {
        var windowSize = document.documentElement.clientWidth;
        const currentSidebarSize = document.documentElement.getAttribute('data-sidebar-size');
        const isCurrentlyVisible = document.body.classList.contains('vertical-sidebar-enable') || currentSidebarSize === 'lg' || !currentSidebarSize;

        if (windowSize > 767)
            document.querySelector(".hamburger-icon")?.classList.toggle('open');

        if (windowSize <= 767) {
            // Mobile: toggle overlay sidebar
            if (document.body.classList.contains('vertical-sidebar-enable')) {
                document.body.classList.remove('vertical-sidebar-enable');
            } else {
                document.body.classList.add('vertical-sidebar-enable');
                document.documentElement.setAttribute('data-sidebar-size', 'lg');
            }
        } else {
            // Desktop: toggle between lg and sm (collapsed)
            document.body.classList.remove('vertical-sidebar-enable');
            if (currentSidebarSize === 'sm') {
                document.documentElement.setAttribute('data-sidebar-size', 'lg');
                dispatch(changeSidebarVisibility("show"));
            } else {
                document.documentElement.setAttribute('data-sidebar-size', 'sm');
                dispatch(changeSidebarVisibility("hidden"));
            }
        }

        //For collapse horizontal menu
        if (document.documentElement.getAttribute('data-layout') === "horizontal") {
            document.body.classList.contains("menu") ? document.body.classList.remove("menu") : document.body.classList.add("menu");
        }


        //Two column menu
        if (document.documentElement.getAttribute('data-layout') === "twocolumn") {
            document.body.classList.contains('twocolumn-panel') ? document.body.classList.remove('twocolumn-panel') : document.body.classList.add('twocolumn-panel');
        }
    };

    return (
        <React.Fragment>
            <header id="page-topbar" className={headerClass}>
                <div className="layout-width">
                    <div className="navbar-header">
                        <div className="d-flex">

                            <div className="navbar-brand-box horizontal-logo">
                                <Link to="/admin" className="logo logo-light d-flex align-items-center text-decoration-none" style={{ gap: 8 }}>
                                    <span className="logo-sm">
                                        <img src="/logo.png" alt="Oplena" style={{ width: 32, height: 32, display: "block" }} />
                                    </span>
                                    <span className="logo-lg d-flex align-items-center" style={{ gap: 8 }}>
                                        <img src="/logo.png" alt="Oplena" style={{ width: 32, height: 32, display: "block" }} />
                                        <span className="fw-bold fs-5 text-white">Oplena</span>
                                    </span>
                                </Link>
                            </div>

                            <button
                                onClick={toogleMenuBtn}
                                type="button"
                                className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
                                id="topnav-hamburger-icon">
                                <span className="hamburger-icon">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </span>
                            </button>
                        </div>

                        <div className="d-flex align-items-center">
                            {/* FullScreenDropdown */}
                            <FullScreenDropdown />

                            {/* ProfileDropdown */}
                            <ProfileDropdown />
                        </div>
                    </div>
                </div>
            </header>
        </React.Fragment>
    );
};

export default Header;